import { Helmet } from "react-helmet";
import GamePlayLayout from "../sections/gamePlay/gamePlayLayout";

const LearnWithCuddlesPage = () => {
    <Helmet>
        <title>Learn With Cuddles</title>
        <meta name="description" content="Jump into the Learn with Cuddles game! Trace numbers, recognize them, and go fishing with Cuddles the penguin. Play levels that teach counting, number order, and early math in a super fun way." />
        <meta name="keywords" content="Play Learn with Cuddles, kids math game, number tracing game, number recognition, counting fun, penguin game, math adventure for kids, playful number learning, preschool math practice" />
        <link rel="canonical" href="https://cuddles.edliena.com/play" />
    </Helmet>

    return (
        <>
            <GamePlayLayout />
        </>
    );
}

export default LearnWithCuddlesPage;